import { ButtonPrimary } from "@nova/component-btn"
import { useAppSelector } from "integrations/redux/hooks"
import { selectUserLicense } from "user/profile/selectors"
import * as Icons from "@nova/component-icons"
import { Licenses, LicenseCapacitiesInBytes } from "@nova/constants"
import { useTranslation } from "@nova/use-translation"
import { usePaywalls } from "features/entity-caching/licenses/useLicensePaywall"
import { formatBytes } from "@nova/format"

export const GenericDataUsage = ({ remainingBytes = 0 }: { remainingBytes?: number }) => {
    const { t } = useTranslation()
    const { showLicensePaywallModal } = usePaywalls()

    const license = useAppSelector(selectUserLicense)
    const usage = license?.usageAmount ?? 0
    const amountExceeded =
        usage - LicenseCapacitiesInBytes[(license?.subscriptionType as Licenses) ?? Licenses.Lite]

    return (
        <div>
            <div className="flex gap-2 mt-4">
                <Icons.SmallIcon Icon={Icons.Error} className="text-red-500" />
                <h5 className="text-gray-0">{t("Data Usage Exceeded")}</h5>
            </div>
            {!remainingBytes ? (
                <div className="flex flex-col my-2">
                    <div>
                        <small className="text-gray-100 mr-1">
                            {t(`You've surpassed your data usage by `)}
                        </small>
                        <small className="mono text-gray-0">{formatBytes(amountExceeded)}.</small>
                    </div>
                </div>
            ) : (
                <div className="flex items-end my-2">
                    <small className="text-gray-100 mr-1">You require an additional</small>
                    <small className="text-gray-0 mono">{formatBytes(remainingBytes)}</small>
                </div>
            )}
            <ButtonPrimary
                title={"Upgrade License"}
                className="w-full"
                RightIcon={Icons.ArrowRight}
                onClick={() => showLicensePaywallModal("usage")}
            />
        </div>
    )
}
